import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { lenisRef } from "@/lib/lenis";
import ErrorBoundary from "@/components/ErrorBoundary";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Features from "@/pages/Features";
import Gallery from "@/pages/Gallery";
import Booking from "@/pages/Booking";
import Electric from "@/pages/Electric";
import Suv from "@/pages/Suv";
import Ishustar from "@/pages/Ishustar";
import Admin from "@/pages/Admin";
import AdminSignup from "@/pages/AdminSignup";
import AdminForgot from "@/pages/AdminForgot";
import AdminReset from "@/pages/AdminReset";
import Account from "@/pages/Account";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Manual from "@/pages/Manual";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import RefundPolicy from "@/pages/RefundPolicy";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <div className="noise-overlay" aria-hidden="true" />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/booking/:slug" element={<Booking />} />
            <Route path="/electric" element={<Electric />} />
            <Route path="/suv" element={<Suv />} />
            <Route path="/ishustar" element={<Ishustar />} />
            <Route path="/roadster" element={<Ishustar />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/signup" element={<AdminSignup />} />
            <Route path="/admin/forgot" element={<AdminForgot />} />
            <Route path="/admin/reset" element={<AdminReset />} />
            <Route path="/account" element={<Account />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/manual" element={<Manual />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </ErrorBoundary>
  );
}